(function() {
    /** @ngInject */
    function waitlistPageController($scope,$http, $state, Booking, $document,$timeout){

        $scope.times = [Booking.time];


        getMin = function(){
            if($scope.times.length > 0) {
                var m = $scope.times[0];
                for(x in $scope.times){
                    if(m < $scope.times[x]){
                        m = $scope.times[x];
                    }
                }
                return m;
            }
        };

        getMax = function(){
            if($scope.times.length > 0) {
                var m = $scope.times[0];
                for(x in $scope.times){
                    if(m > $scope.times[x]){
                        m = $scope.times[x];
                    }
                }
                return m;
            }
        };

        $scope.firstTime = getMin();
        $scope.lastTime = getMax();

        $scope.toggleWaTime = function(time){
            for(x in $scope.times){
                if($scope.times[x] == time) {
                    $scope.times.splice(x,$scope.times.length - x);
                    $scope.firstTime = getMin();
                    $scope.lastTime = getMin();
                    return;
                }
            }

            if(time < $scope.firstTime || !$scope.firstTime) {
                $scope.firstTime = time;
            }
            if(time > $scope.lastTime || !$scope.lastTime) {
                $scope.lastTime = time;
            }

            $scope.times = [];
            for(x in $scope.booking.last_timelist_full){
                if($scope.booking.last_timelist_full[x][0] >=  $scope.firstTime && $scope.booking.last_timelist_full[x][0] <= $scope.lastTime){
                    $scope.times.push($scope.booking.last_timelist_full[x][0]);
                }
            }
        };
        $scope.next = function(go){
            if(typeof(go) === 'undefined' && $scope.firstTime == $scope.lastTime ) {
                if(!confirm((lang.waitlist_range || 'Please note that you can set a range. Or click ok to only be on wait list for') + ' '  + $scope.firstTime)) {
                    return;
                }
            }
            Booking.waitlist_end = $scope.lastTime;
            Booking.time = $scope.firstTime;
            $state.go('guest-details', {}, {location : false});
            //$state.go('products', {}, {location : false});
        };
        $scope.back = function(){
            resetList();
            $state.go('time', {}, {location : false});
        };
        $scope.isTimeActive = function(t){
            for(x in $scope.times){
                if($scope.times[x] == t) {
                    return true;
                }
            }
            return false;
        };
        $scope.isTimeSelected = function(t){
            return $scope.times[0] == t || $scope.times[$scope.times.length - 1] == t;
        };
        $scope.getTimelist = function(){
            return $scope.booking.last_timelist_full;
        };
        if(Booking.waitlist_end && Booking.waitlist_end > Booking.time){
            $scope.toggleWaTime(Booking.waitlist_end);
        }
        $scope.$on("$viewContentLoaded", function() {
            updateWidgetStep('Waitlist', {averageValue : $scope.booking.meal.avg_gtm_price, totalValue : ($scope.booking.meal.avg_gtm_price*$scope.booking.amount),meal : $scope.booking.meal.name,mealId : $scope.booking.meal.id, amount : $scope.booking.amount, date : $scope.booking.getDate('YYYY-MM-DD')});
        });
    }
    angular.module("Waiteraid").controller("wtimeCtrl", waitlistPageController);
})();
